module.exports = __webpack_public_path__ + "static/media/romstandard3.c6a691ff.jpeg";